// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-LUNFV","consent":"consent-3EG5Z","disableTermsOfTariff":"disableTermsOfTariff-21Evp"};